// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gwPurple": "#795de9",
	"gwDarkPurple": "#291758",
	"gwPrimaryDarkPurple20": "#d4d1de",
	"gwPrimaryDarkPurple70": "#6a5d8a",
	"gwLightPurple": "#e3ddf3",
	"gwLightPurple20": "#beb6d4",
	"gwBackgroundPurple": "#f6f5fb",
	"gwBackgroundGray": "#f8f8f8",
	"gwRed": "#ff7b69",
	"gwOrange": "#ffb471",
	"gwYellow": "#ffe340",
	"gwYellowGreen": "#cde075",
	"gwGreen": "#8dda80",
	"gwBlueGreen": "#5da7b5",
	"gwBackgroundRed": "#ffefec",
	"gwLinkBlue": "#007aff",
	"gwErrorRed": "#d73d17",
	"gwValidationGreen": "#25883b",
	"gwInfoBlue": "#1751d7",
	"gwWarningYellow": "#d79d17",
	"gwGray100": "#5f6369",
	"gwGray80": "#7f8287",
	"gwGray60": "#9fa1a5",
	"gwGray40": "#bfc1c3",
	"gwGray20": "#dfe0e1",
	"white": "#fff",
	"black": "#222",
	"bluePrimary": "#00a4f0",
	"blueDark": "#245e82",
	"blueLight": "#ccedfc",
	"blueBackground": "#f2fafe",
	"blueDark20": "#d3dfe6",
	"blueDark70": "#668ea7",
	"deepBluePrimary": "#3453c6",
	"deepBlueDark": "#192a63",
	"deepBlueLight": "#d1d4e0",
	"deepBlueBackground": "#e9eaef",
	"deepBlueDark20": "#a4b7ff",
	"deepBlueDark70": "#485582",
	"brownPrimary": "#726b60",
	"brownDark": "#3a3530",
	"brownLight": "#e3e1df",
	"brownBackground": "#f1f0ef",
	"brownDark20": "#d5c8b8",
	"brownDark70": "#5b554d",
	"deepGreenPrimary": "#447753",
	"deepGreenDark": "#223d2a",
	"deepGreenLight": "#d9e4dd",
	"deepGreenBackground": "#ecf1ee",
	"deepGreenDark20": "#365f42",
	"deepGreenDark70": "#152419",
	"greenPrimary": "#00873f",
	"greenDark": "#165e38",
	"greenLight": "#cce7d9",
	"greenBackground": "#f2f9f5",
	"greenDark20": "#d0dfd7",
	"greenDark70": "#5c8e74",
	"purplePrimary": "#d44696",
	"purpleDark": "#723685",
	"purpleLight": "#f6daea",
	"purpleBackground": "#fdf6fa",
	"purpleDark20": "#e3d7e7",
	"purpleDark70": "#9c72aa",
	"deepTealPrimary": "#40747d",
	"deepTealDark": "#203b3e",
	"deepTealLight": "#d9e3e5",
	"deepTealBackground": "#ecf1f2",
	"deepTealDark20": "#40747d",
	"deepTealDark70": "#2e5158",
	"tealPrimary": "#37dbc5",
	"tealDark": "#007e6e",
	"tealLight": "#d7f8f3",
	"tealBackground": "#f5fdfc",
	"tealDark20": "#cce5e2",
	"tealDark70": "#4ca599",
	"whitelabelPrimary": "#000",
	"whitelabelDark": "#00a94f",
	"whitelabelLight": "#ccc",
	"whitelabelBackground": "#f2f9f5",
	"whitelabelDark20": "#cceedc",
	"whitelabelDark70": "#4dc384",
	"fontSerif": "\"BradfordBook\",serif",
	"fontSerifLight": "\"BradfordLight\",serif",
	"fontSanserif": "\"ProximaNova\",sans-serif",
	"fontSanserifSemiBold": "\"ProximaNovaSemibold\",sans-serif"
};
export default ___CSS_LOADER_EXPORT___;
